module.exports = __webpack_public_path__ + "img/post.fc324fc6.png";